import { sessionStore } from '@/store/stage2/SessionStore';

/**
 * Checks if all assigned forms are completed based on patientSessionInfo
 * @returns true if all assigned forms have a completedAtISO timestamp, false otherwise
 */
export function areAllFormsCompleted(): boolean {
  return sessionStore.areAllFormsCompleted();
}
